export default __webpack_public_path__ + "static/media/image-51.caa22293.webp";